import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, makeStyles } from '@material-ui/core';
import CountryFormatHelper from '../../../components/elements/CountryFormatHelper';

const useStyles = makeStyles({
  invoiceDateColumn: {
    minWidth: 130,
  },
});

const DateByCountry = React.memo(props => {
  const { text, countryId } = props;
  const classes = useStyles();
  return (
    <Typography
      variant="body1"
      color="textSecondary"
      component="div"
      noWrap
      className={classes.invoiceDateColumn}
    >
      <Box fontWeight="fontWeightBold">
        <CountryFormatHelper
          value={text}
          variant="longdate"
          countryId={countryId}
        />
      </Box>
    </Typography>
  );
});

DateByCountry.defaultProps = {};

DateByCountry.propTypes = {
  text: PropTypes.string.isRequired,
  countryId: PropTypes.string.isRequired,
};

export default DateByCountry;
